import * as React from "react";
import { useCallback, useEffect } from "react";
import { HoverForHelp } from "components/common";
import useSearchConfiguration from "hooks/useSearchConfiguration";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { getPathnameWithoutId } from "util/URLUtils";
import useLocation from "routing/useLocation";
import useMinimumRefreshInterval from "views/hooks/useMinimumRefreshInterval";
import RefreshControls from "components/common/RefreshControls";
import useDefaultInterval from "views/hooks/useDefaultIntervalForRefresh";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import useTableFetchContext from "../../common/PaginatedEntityTable/useTableFetchContext";
const useDisableRefreshWhileSlicing = () => {
  const tableFetchContext = useTableFetchContext();
  const { refreshConfig, stopAutoRefresh } = useAutoRefresh();
  const isSlicingEnabled = Boolean(tableFetchContext == null ? void 0 : tableFetchContext.searchParams.sliceCol);
  useEffect(() => {
    if (isSlicingEnabled && (refreshConfig == null ? void 0 : refreshConfig.enabled)) {
      stopAutoRefresh();
    }
  }, [isSlicingEnabled, refreshConfig == null ? void 0 : refreshConfig.enabled, stopAutoRefresh]);
  return isSlicingEnabled;
};
const EventsRefreshControls = () => {
  const location = useLocation();
  const sendTelemetry = useSendTelemetry();
  const { config } = useSearchConfiguration();
  const autoRefreshTimerangeOptions = config == null ? void 0 : config.auto_refresh_timerange_options;
  const { data: minimumRefreshInterval, isInitialLoading: isLoadingMinimumInterval } = useMinimumRefreshInterval();
  const isSlicingEnabled = useDisableRefreshWhileSlicing();
  const onSelectInterval = useCallback(
    (interval) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_REFRESH_CONTROL_PRESET_SELECTED, {
        app_pathname: getPathnameWithoutId(location.pathname),
        app_section: "alerts-page",
        app_action_value: "refresh-alerts-control-dropdown",
        event_details: { interval }
      });
    },
    [location.pathname, sendTelemetry]
  );
  const onToggle = useCallback(
    (enabled) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_REFRESH_CONTROL_TOGGLED, {
        app_pathname: "alerts",
        app_section: "alerts-page",
        app_action_value: "refresh-alerts-control-enable",
        event_details: { enabled }
      });
    },
    [sendTelemetry]
  );
  const defaultInterval = useDefaultInterval();
  if (!config) {
    return null;
  }
  const intervalOptions = autoRefreshTimerangeOptions ? Object.entries(autoRefreshTimerangeOptions) : [];
  return /* @__PURE__ */ React.createElement(
    RefreshControls,
    {
      disable: isSlicingEnabled,
      intervalOptions,
      isLoadingMinimumInterval,
      minimumRefreshInterval,
      defaultInterval,
      humanName: "Events",
      onToggle,
      onSelectInterval
    },
    isSlicingEnabled && /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Auto refresh unavailable", placement: "left", pullRight: false, iconSize: "sm" }, "Auto refresh is turned off during slicing to avoid performance issues.")
  );
};
export default EventsRefreshControls;
